module.exports = __webpack_public_path__ + "img/img_webinar1.048b0af9.jpg";